(ns frontend.test.filters.view
    (:require
      [clojure.string :as string]
      [common.schema.registry :as registry]
      [re-frame.core :as rf]
      [ui.editors.simple-filters.event :as filters-event]
      [ui.editors.simple-filters.view :as filters-editor]))

(def editor-id "frontend.test.filters/screening-profile")

(defn- schema->fields
  [schema]
  (->> schema
       (keep (fn [[attribute field-schema]]
               (let [filter-kind (get-in field-schema [:field/default-visibility :filter])]
                 (when (and (keyword? attribute)
                            (not (true? (:field/hidden-from-configuration? field-schema)))
                            (not= filter-kind :filter.type/none)
                            (not= filter-kind :editor.type/none))
                   {:field-path        [attribute]
                    :field/name        (str attribute)
                    :field/label       (or (get-in field-schema [:field/translations :en])
                                           (name attribute))
                    :field/attribute   attribute
                    :field/data-type   (:field/data-type field-schema)
                    :field/filter-type filter-kind
                    :field/options     (or (:options field-schema) [])
                    :field/default-ord (or (:field/default-ord field-schema) 0)
                    :field/schema      field-schema
                    :readable?         true}))))
       (sort-by :field/default-ord)
       vec))

(def screening-profile-fields
  (-> (registry/get-schema nil :entity.type/screening-profile)
      (schema->fields)))

(defn- option-value
  [option]
  (or (:value option)
      (:key option)
      (:keyword option)))

(defn- option-label
  [option value]
  (or (:label option)
      (when (keyword? value)
        (name value))
      (str value)))

(defn- randomize-count
  []
  (inc (rand-int 250)))

(defn- field->mock-facets
  [field search-text offset limit]
  (let [q (string/lower-case (or search-text ""))
        offset (max 0 (or offset 0))
        limit (max 1 (or limit 50))
        field-options (->> (or (:field/options field) [])
                           (keep (fn [option]
                                   (let [value (option-value option)]
                                     (when (some? value)
                                       {:value value
                                        :label (option-label option value)
                                        :count (randomize-count)}))))
                           vec)
        defaults [{:value :facet/mock-a :label "Alpha" :count (randomize-count)}
                  {:value :facet/mock-b :label "Beta" :count (randomize-count)}
                  {:value :facet/mock-c :label "Gamma" :count (randomize-count)}]
        base-options (if (seq field-options) field-options defaults)
        filtered-options (->> base-options
                              (filter (fn [{:keys [label]}]
                                        (or (string/blank? q)
                                            (-> label string/lower-case (string/includes? q)))))
                              vec)
        page-options (->> filtered-options
                          (drop offset)
                          (take limit)
                          vec)
        next-offset (+ offset (count page-options))
        has-more? (< next-offset (count filtered-options))]
    {:options page-options
     :append? (> offset 0)
     :next-offset next-offset
     :has-more has-more?}))

(rf/reg-event-fx
 ::load-facets-mock
 (fn [_ [_ {:keys [editor-id field-path search-text offset limit]}]]
   (let [field (some (fn [f]
                       (when (= (:field-path f) field-path)
                         f))
                     screening-profile-fields)
         response (field->mock-facets field search-text offset limit)]
     {:fx [[:dispatch [::filters-event/set-field-facets-loading editor-id field-path true]]
           [:dispatch [::filters-event/set-field-facets editor-id field-path response]]]})))

(def init-args
  {:view-id                   "test-screening-profile-filters"
   :entity-type               :entity.type/screening-profile
   :fields                    screening-profile-fields
   :load-facets-event         [::load-facets-mock]
   :po-configured-field-paths [[:screening-profile/screening-status]
                               [:common/updated-on]
                               [:screening-profile/type]]
   :pinned-field-paths        [[:screening-profile/sanction-status]]
   :runtime-field-paths       [[:screening-profile/country]
                               [:screening-profile/pep-status]
                               [:screening-profile/business-id]]
   :filters-by-field-path     {[:screening-profile/sanction-status]
                               {:mode       :multi
                                :selections [{:kind  :value
                                              :value :sanction-status/yellow}]}
                               [:screening-profile/type]
                               {:mode       :multi
                                :selections [{:kind  :value
                                              :value :screening-profile-type/company}]}
                               [:screening-profile/country]
                               {:mode       :multi
                                :selections [{:kind  :value
                                              :value :FI}]}}})

(defn view
  []
  [:div
   {:class "p-6 max-w-5xl"}
   [filters-editor/view
    {:editor-id editor-id
     :init-args init-args}]])
